import { render, staticRenderFns } from "./weChatList.vue?vue&type=template&id=0ba4146d&scoped=true"
import script from "./weChatList.vue?vue&type=script&lang=js"
export * from "./weChatList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba4146d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ba4146d')) {
      api.createRecord('0ba4146d', component.options)
    } else {
      api.reload('0ba4146d', component.options)
    }
    module.hot.accept("./weChatList.vue?vue&type=template&id=0ba4146d&scoped=true", function () {
      api.rerender('0ba4146d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adver/weChatList.vue"
export default component.exports